import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal, Table, TableColumnsType } from 'antd';
import useAxios from '../../hooks/useAxios';
import Loader from '../Spinner';
import ErrorResponse from '../ErrorResponse';
import {
  IGetSpeakingRubricList,
  ISpeakingRubricListItem,
} from '../../models/newSpeaking.model';
import { getSpeakingRubricList } from '../../api/newSpeaking.api';
import { TableRowSelection } from 'antd/es/table/interface';
import useNotification from '../../hooks/useNotification';

interface IProps {
  visible: boolean;

  onCancel(): void;

  onOk(rubric: ISpeakingRubricListItem): void;
}

const SelectSpeakingItemModal: FC<IProps> = ({ visible, onCancel, onOk }) => {
  const { t } = useTranslation();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetSpeakingRubricList>();
  const { infoNotification } = useNotification();

  const [rubric, setRubric] = useState<ISpeakingRubricListItem | undefined>();

  useEffect(() => {
    execute(getSpeakingRubricList());
  }, []);

  const rowSelection: TableRowSelection<ISpeakingRubricListItem> = {
    type: 'radio',
    onChange: (selectedRowKeys, selectedRows) => {
      if (selectedRows.length === 1) setRubric(selectedRows[0]);
    },
  };

  const onSubmit = () => {
    if (!rubric) return infoNotification(t('cbt.speakTest.message9'));
    onOk(rubric);
  };

  const columns: TableColumnsType<ISpeakingRubricListItem> = [
    {
      title: t('cbt.speakTest.column1'),
      dataIndex: 'rubricName',
      key: 'rubricName',
      align: 'center',
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <Modal
        title={t('cbt.speakTest.column8')}
        visible={visible}
        onCancel={onCancel}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton key="submit" className='btn-basic pink' onClick={onSubmit}>
              {t('common.button.save')}
            </AntButton>
            <AntButton key="cancel" className='btn-basic gray' onClick={onCancel}>
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <div className='comm-table__area mt-0'>
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={res?.data}
            rowKey="rubricNo"
          />
        </div>
      </Modal>
    </>
  );
};

export default SelectSpeakingItemModal;
